import React from 'react';
import { Link } from 'react-router-dom';

const RoomsList = ({ roomListings, query }) => {
  return (
    <div style={{ background: "#f9f9f9" }}>
      <div className="container">
        <div className="list-view row content grid">
          {roomListings.length > 0 ? roomListings.map((room) => (
            <div key={room.id} className="list-box col-12 popular grid-item wow fadeInUp">
              <div className="list-img">
                <Link to={`/Viewroomdetails?${query}&id=${room.id}`} className="img-link">
                  <img
                    src={`https://admin.abhyaranyan.com/RoomsUploadimage/${room.roomImage}`}
                    className="img-fluid blur-up lazyload"
                    alt={room.roomType}
                  />
                </Link>
              </div>
              <div className="list-content">
                <div className="offer-box">
                  <i className="fas fa-fire"></i> {room.airCondition}
                </div>
                <div>
                  <h5>{room.roomType}</h5>
                  <h5>{room.location}</h5>
                  <p>{room.description}</p>
                  <div className="rating">
                    {[...Array(5)].map((_, index) => (
                      <i key={index} className={`fas fa-star ${index < room.rating ? 'filled' : ''}`}></i>
                    ))}
                    <span>{room.reviews} reviews</span>
                  </div>
                  <div className="price">
                    <p className="mb-0">
                      {room.oldRent && <del>₹{room.oldRent}</del>}
                      ₹{room.rent} <span>/ per night</span>
                    </p>
                    <p className="mb-0">Login & unlock a secret deal</p>
                  </div>
                  <Link 
                    to={`/Viewrooms?${query}&id=${room.id}`} 
                    className="btn btn-solid color1 book-now"
                  >
                    Book Now
                  </Link>
                </div>
              </div>
            </div>
          )) : (
            <div className="col-12 text-center py-5">
              <p>No rooms available for the selected dates.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RoomsList;
